import React from "react";
import "./styles.css";

export default function Wave({
    color = "#fff",
    flip = false,
    showShadow = false,
    position = "relative",
    zIndex = 0,
}) {
    const classes = ["wave"];
    if (showShadow) {
        classes.push("wave--shadow");
    }
    return (
        <div style={{ display: "inline-block", zIndex }} className={classes.join(" ")}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 1280.1 137.31"
                style={{
                    marginBottom: -5,
                    transform: flip ? "scaleX(-1)" : "",
                }}
            >
                <path
                    fill={color}
                    d="M928.1,51.41C724.4,99.41,593.8,1,384.2,0S0,100.81,0,100.81v36.5H1280v-29.9h.1v-6.7S1131.8,3.41,928.1,51.41Z"
                />
            </svg>
        </div>
    );
}
